import { render, staticRenderFns } from "./vuecomm03xy.vue?vue&type=template&id=1d38155e&scoped=true"
import script from "./vuecomm03xy.vue?vue&type=script&lang=js"
export * from "./vuecomm03xy.vue?vue&type=script&lang=js"
import style0 from "./vuecomm03xy.vue?vue&type=style&index=0&id=1d38155e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d38155e",
  null
  
)

export default component.exports